module.exports = {
	widthStageLeft: '88%',
	// Tooltip square size
	squareTooltip: '1.25rem',
	// Brand header. Phone 44px; Tablet 50px
	heightHeader: '2.75rem',
	// Maximum width for action overflow menu so that it's not full-screen for tablet.
	maxWidthActionOverflowMenu: '512px',
	// Maximum width for brand logos in header.
	maxWidthHeaderBrand: '156px',
	// Tap target Size
	squareTappable: '2.75rem',
	// Tooltip nubbin square size
	squareTooltipNubbin: '1rem',
	// Use squareIconLargeBoundary
	squareRecordAnchorPic: '3rem',
	// 2 Column Layout - Master
	flexMasterPanel: '7',
	// Maximum height for photos and such in cards.
	maxHeightCardMedia: '144px',
	// Text input height
	heightInput: '1.875rem',
	// Maximum height for brand logos in header.
	maxHeightHeaderBrand: '32px',
	// Action footer menu. Phone 44px; Tablet 50px
	heightFooter: '3.75rem',
	// Maximum width for action icons in action bar when there are only 2 items with labels.
	maxWidthActionBarWithLabels: '320px',
	// 2 Column Layout - Detail
	flexDetailPanel: '3',
	// Space above overflow menu before scrolling.
	heightOverflowStart: '144px',
	durationSlide: '0.25s',
};
